import axiosInstance from "./axiosConfig";

const API_URL = process.env.REACT_APP_API_URL;

// Obtener usuarios por companyId
export const getUsersByCompanyId = async (companyId) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/users/${companyId}`);
        return response;
    } catch (error) {
        throw new Error(error.message);
    }
};

// Guardar (crear o actualizar) un usuario
export const saveUser = async (user) => {
    try {
        const method = user.id ? 'put' : 'post';
        const response = await axiosInstance[method](`${API_URL}/user`, user);
        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
};

// Eliminar un usuario por ID
export const deleteUser = async (id) => {
    try {
        const response = await axiosInstance.delete(`${API_URL}/user/${id}`);
        return response.data;
    } catch (error) {
        throw new Error(error.message);
    }
};
